import Fetch from 'utils/fetch'

export const searchBusinessUnit = () => {
    return  Fetch.get(`/unidadeNegocio/unidadeGeral`).then(({ data }) => data)
}